module.exports = __webpack_public_path__ + "static/media/slider-img3.1af1e773.jpg";